import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import Hls from 'hls.js';

// react-player's HLS backend looks for a `window.Hls` global before falling
// back to loading hls.js from a CDN at runtime (no error handling on that
// path). Registering the bundled hls.js dependency here avoids that network
// dependency — critical when the network is already unstable.
window.Hls = Hls;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter> 
  </React.StrictMode>
);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
